// file: Item.component.tsx

import React from 'react';
import {Group, Button, rem} from '@mantine/core';
import {IconArrowRight} from '@tabler/icons-react';
// import reference to our interface
import {JobInterface} from '../../../models/jobs/Job.interface';

// example using class syntax
export class JobComponent extends React.Component<{
  model: JobInterface;
}> {
  // <div className="name">{model.name} [{String(model.selected)}]</div>

  render(): React.ReactNode {
    const {model} = this.props;

    return (
      <li className={'job-box p-4'}>
        <h3>{model.title}</h3>
        <div>
          <span>{model.location}</span>
        </div>
        <div className="mt-2 pb-2">
          <span>{model.work_patterns}</span>
        </div>
        <div className="mt-2 pb-4">
          <span>{model.annual_salary}</span>
        </div>

        <Group position="left">
          <Button
            component="a"
            href="/job-details"
            rel="noopener noreferrer"
            leftIcon={<IconArrowRight size={rem(18)} />}
            styles={theme => ({
              root: {
                backgroundColor: '#21485e',
                border: 0,
                height: rem(42),
                paddingLeft: rem(20),
                paddingRight: rem(20),
                '&:not([data-disabled])': theme.fn.hover({
                  backgroundColor: '#21485e',
                  color: '#ffffff',
                }),
              },

              leftIcon: {
                marginRight: theme.spacing.md,
              },
            })}
          >
            View Vacancy
          </Button>
        </Group>
      </li>
    );
  }
}
